import {ModalSize, SuiModalService} from '@angular-ex/semantic-ui';
import {Component, Input} from '@angular/core';

import {InternalMessage} from '../../../core/models/internal-message/internal-message.model';
import {InternalMessagesService} from '../../../core/services/internal-messages/internal-messages.service';
import {ToastService} from '../../../core/services/toast/toast.service';
import {InternalMessageFormModal} from '../../forms/internal-message-form-modal/internal-message-form-modal.component';
import {
  InternalMessageFormModalContext,
  InternalMessageFormValues,
} from '../../forms/internal-message-form-modal/internal-message-form-modal.model';
import {AlertModal} from '../../modals/alert-modal/alert-modal.component';

@Component({
  selector: 'app-internal-messages-list',
  templateUrl: './internal-messages-list.component.html',
  styleUrls: ['./internal-messages-list.component.css'],
  standalone: false,
})
export class InternalMessagesListComponent {
  @Input() internalMessages!: InternalMessage[];
  // show in column if internal message is ready to send
  @Input() showPlanned = false;
  @Input() showSaved = false;
  @Input() sendingDate!: Date;
  @Input() actions = false;

  constructor(
    private internalMessagesService: InternalMessagesService,
    private modalService: SuiModalService,
    private toastService: ToastService,
  ) {
  }

  setSend(internalMessage: InternalMessage, send: boolean) {
    internalMessage.readyToSend = send;
    this.internalMessagesService.updateOne(internalMessage).subscribe(newInternalMessage => {
      this.internalMessages[this.internalMessages.indexOf(internalMessage)] = newInternalMessage;
      this.toastService.success(
        $localize`:@@internal-messages-send-success-title:Interne Mitteilung aktualisiert`,
        $localize`:@@internal-messages-send-success-message:Die interne Mitteilung ${!send ? $localize`:@@internal-messages-not-anymore:ist nun nicht mehr` : $localize`:@@internal-messages-was-successfully:wurde erfolgreich`} für den Versand eingeplant.`);
    }, error => {
      this.toastService.error(
        $localize`:@@internal-messages-send-error-title:Interne Mitteilung nicht aktualisiert`,
        $localize`:@@internal-messages-send-error-message:Die interne Mitteilung konnte nicht für den Versand geplant werden.`,
        error);
    });
  }

  edit(editMessage: InternalMessage) {
    this.modalService.open<InternalMessageFormModalContext, InternalMessageFormValues, void>(new InternalMessageFormModal({
      title: editMessage.title,
      editMessage,
    }, ModalSize.Large)).onApprove((result: InternalMessageFormValues) => {
      editMessage.title = result.title;
      editMessage.text = result.text;
      editMessage.extraInfo = result.extraInfo;
      editMessage.saved = result.saved;

      this.internalMessagesService.updateOne(editMessage).subscribe(newInternalMessage => {
        this.internalMessages[this.internalMessages.indexOf(editMessage)] = newInternalMessage;
        this.toastService.success(
          $localize`:@@internal-messages-edit-success-title:Interne Mitteilung bearbeitet`,
          $localize`:@@internal-messages-edit-success-message:Die interne Mitteilung wurde erfolgreich bearbeitet.`,);
      }, error => {
        this.toastService.error(
          $localize`:@@internal-messages-edit-error-title:Interne Mitteilung nicht bearbeitet`,
          $localize`:@@internal-messages-edit-error-message:Die interne Mitteilung konnte nicht bearbeitet werden.`,
          error);
      });
    });
  }

  delete(internalMessage: InternalMessage) {
    this.modalService.open(new AlertModal(
      $localize`:@@internal-messages-delete-confirmation-title:Interne Mitteilung "${internalMessage.title}" löschen?`,
      $localize`:@@internal-messages-delete-confirmation-message:Soll diese Interne Mitteilung wirklich gelöscht werden? Dieser Vorgang kann nicht rückgängig gemacht werden!`,
    )).onApprove(() => {
      this.internalMessagesService.deleteOne(internalMessage).subscribe(() => {
        this.internalMessages.splice(this.internalMessages.indexOf(internalMessage), 1);
        this.toastService.warning(
          $localize`:@@internal-messages-delete-success-title:Interne Mitteilung gelöscht`,
          $localize`:@@internal-messages-delete-success-message:Die interne Mitteilung wurde erfolgreich gelöscht.`,);
      }, error => {
        this.toastService.error(
          $localize`:@@internal-messages-delete-error-title:Interne Mitteilung nicht gelöscht`,
          $localize`:@@internal-messages-delete-error-message:Die interne Mitteilung konnte nicht gelöscht werden.`,
          error);
      });
    });
  }

  send(internalMessage: InternalMessage){
    this.internalMessagesService.sendInternalMessageMail(internalMessage).subscribe(newInternalMessage => {
      this.internalMessages[this.internalMessages.indexOf(internalMessage)] = newInternalMessage;
      this.toastService.success(
        $localize`:@@internal-messages-send-now-success-title:Interne Mitteilung gesendet`,
        $localize`:@@internal-messages-send-now-success-message:Die interne Mitteilung wurde erfolgreich gesendet.`,);
    }, error => {
      this.toastService.error(
        $localize`:@@internal-messages-send-now-error-title:Interne Mitteilung nicht gesendet`,
        $localize`:@@internal-messages-send-now-error-message:Die interne Mitteilung konnte nicht gesendet werden.`,
        error);
    });
  }
}
